module.exports = __webpack_public_path__ + "static/media/playBtn.6e4e0bca.svg";